import { Comment } from '@readcloud/data';
import {
  authSelectors,
  commentsActions,
  usersSelectors,
} from '@readcloud/state';
import * as React from 'react';
import { useSelector } from 'react-redux';
import { UserComment } from './UserComment';

// TODO: reader-wrapper is depending on new-reader, which is depending on reader-wrapper... we need to properly type our redux somehow
import { useAppDispatch } from '@readcloud/state';

interface IConnectedCommentProps {
  comment: Comment;
}

export const ConnectedUserComment: React.FunctionComponent<
  IConnectedCommentProps
> = (props) => {
  const knownUsers = useSelector(usersSelectors.getKnownUsers);
  const user = useSelector(authSelectors.getUser);

  const dispatch = useAppDispatch();

  const UpdateComment = (updatedCommentText: string) => {
    dispatch(
      commentsActions.asyncActions.updateComment({
        ...props.comment,
        updated: new Date().toISOString(),
        clientUpdated: new Date().toISOString(),
        text: updatedCommentText,
      })
    );
  };

  const DeleteComment = (id: string) => {
    dispatch(commentsActions.asyncActions.deleteComment(id));
  };

  return (
    <UserComment
      comment={props.comment}
      knownUsers={knownUsers}
      user={user}
      UpdateComment={UpdateComment}
      DeleteComment={DeleteComment}
    />
  );
};
